import { render, staticRenderFns } from "./ExcelFileUpload.vue?vue&type=template&id=23d6078e&scoped=true&"
import script from "./ExcelFileUpload.vue?vue&type=script&lang=js&"
export * from "./ExcelFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d6078e",
  null
  
)

export default component.exports